import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchSeasonHighsData = args => {
    return doDefaultFetch(
        `/site/api/${args.entity}/gameStats/${args.season}/${args.gameType}/${args.reportType}` +
        `?include=${args.reportType}` +
        `&include=game.id` +
        '&include=gameDate' +
        '&include=id' +
        '&include=team.id' +
        '&include=team.triCode' +
        `&include={"path":"team.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        '&include=team.fullName' +
        '&include=team.placeName' +
        '&include=team.commonName' +
        '&include=team.division.id' +
        '&include=team.division.name' +
        '&include=team.conference.id' +
        '&include=team.conference.name' +
        '&include=opponentTeam.id' +
        '&include=opponentTeam.triCode' +
        `&include={"path":"opponentTeam.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        '&include=opponentTeam.fullName' +
        '&include=opponentTeam.placeName' +
        '&include=opponentTeam.commonName' +
        '&include=opponentTeam.division.id' +
        '&include=opponentTeam.division.name' +
        '&include=opponentTeam.conference.id' +
        '&include=opponentTeam.conference.name',
        args
    );
};

const fetchTeamSeasonHighsData = args => {
    return doDefaultFetch(
        `/site/api/team/gameStats/${args.season}/${args.gameType}/${args.type}` +
        `?include=${args.type}` +
        `&include=game.id` +
        `&include=game.homeTeam.id` +
        '&include=gameDate' +
        '&include=id' +
        '&include=team.id' +
        '&include=team.triCode' +
        `&include={"path":"team.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        '&include=team.fullName' +
        '&include=team.placeName' +
        '&include=team.commonName' +
        '&include=team.division.id' +
        '&include=team.division.name' +
        '&include=team.conference.id' +
        '&include=team.conference.name' +
        '&include=opponentTeam.id' +
        '&include=opponentTeam.triCode' +
        `&include={"path":"opponentTeam.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        '&include=opponentTeam.fullName' +
        '&include=opponentTeam.placeName' +
        '&include=opponentTeam.commonName' +
        '&include=opponentTeam.division.id' +
        '&include=opponentTeam.division.name' +
        '&include=opponentTeam.conference.id' +
        '&include=opponentTeam.conference.name',
        args
    );
};

const fetchPlayerSeasonHighsData = args => {
    return doDefaultFetch(
        `/site/api/player/gameStats/${args.season}/${args.gameType}/${args.type}` +
        `?include=${args.type}` +
        `&include=game.id` +
        `&include=game.homeTeam.id` +
        `&include=gameDate` +
        `&include=id` +
        `&include=team.id` +
        `&include=team.triCode` +
        `&include={"path":"team.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        `&include=team.league.abbreviation` +
        `&include=opponentTeam.id` +
        '&include=opponentTeam.fullName' +
        `&include=opponentTeam.triCode` +
        `&include={"path":"opponentTeam.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        `&include=opponentTeam.league.abbreviation` +
        `&include=player.firstName` +
        `&include=player.lastName` +
        `&include=player.id` +
        `&include=player.sweaterNumber` +
        `&include=player.position.positionCode`,
        args
    );
};

const fetchGoalieSeasonHighsData = args => {
    return doDefaultFetch(
        `/site/api/goalie/gameStats/${args.season}/${args.gameType}/${args.type}` +
        `?include=${args.type}` +
        `&include=game.id` +
        `&include=game.homeTeam.id` +
        `&include=gameDate` +
        `&include=id` +
        `&include=team.id` +
        `&include=team.triCode` +
        `&include={"path":"team.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        `&include=team.league.abbreviation` +
        `&include=opponentTeam.id` +
        '&include=opponentTeam.fullName' +
        `&include=opponentTeam.triCode` +
        `&include={"path":"opponentTeam.logos","cayenneExp":"startSeason<=${args.season} and endSeason>=${args.season}"}` +
        `&include=opponentTeam.league.abbreviation` +
        `&include=player.firstName` +
        `&include=player.lastName` +
        `&include=player.id` +
        `&include=player.sweaterNumber` +
        `&include=player.position.positionCode`,
        args
    );
};

export default {
    fetchSeasonHighsData,
    fetchTeamSeasonHighsData,
    fetchPlayerSeasonHighsData,
    fetchGoalieSeasonHighsData
};
